document.addEventListener("DOMContentLoaded", function () {
  async function getCart() {
    const res = await fetch("/cart.js");
    return await res.json();
  }

  async function checkMinimums() {
    const cart = await getCart();

    let alfajoresQty = 0;
    let cookiesQty = 0;

    // recorrer productos del carrito
    cart.items.forEach(item => {
      const title = item.title.toUpperCase();

      // excluir box 6
      if (title.includes("BOX 6")) return;

      if (title.includes("ALFAJOR")) {
        alfajoresQty += item.quantity;
      } else if (title.includes("COOKIE")) {
        cookiesQty += item.quantity;
      }
    });

    let messages = [];

    // ✅ Reglas: solo aplica si hay productos de ese tipo
    if (alfajoresQty > 0 && alfajoresQty < 6) {
      messages.push(`⚠️ You must have at least 6 ALFAJORES in total (you have ${alfajoresQty}).`);
    }

    if (cookiesQty > 0 && cookiesQty < 4) {
      messages.push(`⚠️ You must have at least 4 COOKIES in total (you have ${cookiesQty}).`);
    }

    showWarnings(messages);
    toggleCheckout(messages);
  }

  function showWarnings(messages) {
    let warningBox = document.getElementById("min-warning");
    if (!warningBox) {
      warningBox = document.createElement("div");
      warningBox.id = "min-warning";
      warningBox.style.background = "#fff";
      warningBox.style.color = "darkred";
      warningBox.style.fontWeight = "bold";
      warningBox.style.marginTop = "15px";
      warningBox.style.padding = "12px";
      warningBox.style.borderRadius = "12px";
      warningBox.style.lineHeight = "1.4em";
      warningBox.style.boxShadow = "0 0 8px rgba(0,0,0,0.15)";
      warningBox.style.textAlign = "center";

      // insertarlo en cart drawer, cart page o product
      const container =
        document.querySelector(".cart__footer") ||
        document.querySelector(".drawer__footer") ||
        document.querySelector("form[action*='/cart/add']") ||
        document.body;
      container.prepend(warningBox);
    }

    warningBox.innerHTML = messages.length
      ? messages.join("<br>")
      : "";
  }

  function toggleCheckout(messages) {
    const checkoutBtns = document.querySelectorAll(
      "[name='checkout'], .cart__checkout-button, .shopify-payment-button__button, .shopify-payment-button__button--unbranded"
    );

    checkoutBtns.forEach(btn => {
      if (messages.length > 0) {
        btn.disabled = true;
        btn.style.opacity = "0.5";
        btn.style.cursor = "not-allowed";
      } else {
        btn.disabled = false;
        btn.style.opacity = "1";
        btn.style.cursor = "pointer";
      }
    });
  }

  // Ejecutar al inicio
  checkMinimums();

  // Actualizar cuando cambian cantidades o se abre el drawer
  const observer = new MutationObserver(() => {
    setTimeout(checkMinimums, 300);
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Escuchar cambios de cantidad o botones de add-to-cart
  document.addEventListener("change", e => {
    if (e.target.closest(".quantity__input")) {
      setTimeout(checkMinimums, 300);
    }
  });

  document.addEventListener("click", e => {
    if (
      e.target.closest("[name='add']") ||
      e.target.closest(".quantity__button") ||
      e.target.closest(".cart__update-button")
    ) {
      setTimeout(checkMinimums, 600);
    }
  });
});
